import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GfichierService } from 'src/app/service/gfichier.service';

@Component({
  selector: 'app-correctconnexion',
  templateUrl: './correctconnexion.component.html',
  styleUrls: ['./correctconnexion.component.scss'],
})
export class CorrectconnexionComponent implements OnInit {

  classe: string;
  cours: string;
  login: string;
  mdp: string;

  tabEl = [];

  @Output() eventchild = new EventEmitter();



  constructor(private gfichier: GfichierService) {
    this.classe = "2a"//"2a";
    this.cours =  "231";//"231" //"216";
    this.login = "correction";
    this.mdp = "mdpcorrection##";

  }

  ngOnInit() {
    this.seconnecter();
   }

  seconnecter() {
    this.tabEl[0] = {
      login: this.login,
      mdp: this.mdp,
      cours: this.cours,
      classe: this.classe
    };

    //alert(JSON.stringify(this.tabEl));
    this.gfichier.seconnecterliste(JSON.stringify(this.tabEl)).then(
      successData => {

        // alert(successData);
        if (successData != "erreur") {
          let tab = [];
          this.tabEl[0].type = "data";
          this.tabEl[0].classe = this.classe;
          this.tabEl[0].cours = this.cours;
          this.tabEl[0].data = successData;
          this.eventchild.emit(this.tabEl);


        }
        else
          alert("erreur de connexion");

      },
      rejectData => {
        console.log(rejectData);
      }
    );



  }




}
